{
  "title": "Transfers",
  "approvals": "Approvals",
  "approvalLabel": "Approval",
  "inputter": "Inputter",
  "rejectedBy": "Rejected by",
  "createdDate": "Created date",
  "returnToTransfers": "Return to transfers",
  "fxRateBooking": "FX Rate Booking",
  "transferStatus": {
    "draft": "Draft",
    "book_fx": "Book FX",
    "pending_approval": "Pending approval",
    "ready_for_release": "Ready for release",
    "deleted": "Deleted",
    "rejected": "Rejected"
  },
  "iatStatusBadge": {
    "draft": "Draft",
    "pendingapproval": "Pending approval",
    "pendingfx": "Book FX",
    "failed": "Failed",
    "rejected": "Rejected",
    "processing": "Processing",
    "submitted": "Complete"
  },
  "rate": "Rate",
  "tabs": {
    "actionRequired": "Action Required",
    "processing": "Processing",
    "complete": "Complete",
    "rejectedAndFailed": "Rejected & Failed"
  },
  "table": {
    "headers": {
      "submittedByDateTime": "Created Date",
      "accountName": "Entity",
      "debitAccountName": "Debit Account",
      "creditAccountName": "Credit Account",
      "fixedAmount": "Fixed Amount",
      "status": "Status",
      "action": "Action"
    },
    "dataError": "Access to view transfers for the selected entities is restricted for the current user",
    "dropdown": {
      "view": "View",
      "approve": "Approve",
      "reject": "Reject",
      "requestRates": "Request Live Rates",
      "approveAndRequestRates": "Approve & Request Live Rates",
      "delete": "Delete"
    }
  },
  "dupTradesModal": {
    "title": "Potential Duplicate Trade",
    "description": "A trade with similar details has recently been submitted. If you are confident that these trades are not duplicates, you may continue. If not, please contact us.",
    "continueAnyway": "Continue anyway",
    "table": {
      "tradeId": "Trade ID",
      "entityNameAndtradeId": "Funding Entity & Trade ID",
      "buyAmount": "Buy Amount",
      "sellAmount": "Sell Amount",
      "fixed": "Fixed"
    },
    "hasFailedCount": {
      "title": "Some duplicate checks couldn’t be completed",
      "content": "We couldn’t check {{failedCount}} of your trades for duplicates right now. Please check these trades before continuing."
    }
  },
  "newTransfer": "New Transfer",
  "viewTransfer": "View Transfer",
  "viewTransferError": "Transfer not found",
  "summary": {
    "title": "Summary",
    "youSend": "You send",
    "earliestProcessDate": "Earliest process date:",
    "availableBalance": "Available Balance",
    "submitForApproval": "Submit for approval",
    "requestLiveRate": "Request live rate",
    "bookFx": "Book FX"
  },
  "confirmation": {
    "title": "Confirmation",
    "transferComplete": "Transfer Complete",
    "debitAmount": "Debit amount",
    "creditAmount": "Credit amount",
    "valueDate": "Value date",
    "inputter": "Inputter",
    "approver": "Approver {{number}}",
    "downloadConfirmation": "Download confirmation"
  },
  "transferDetails": {
    "title": "Transfer Details",
    "transfers": "Transfer",
    "entity": {
      "field": "Entity",
      "label": "Select entity",
      "subtitle": "Select which entity to make the transfer from",
      "noOptions": "No entities found"
    },
    "debitAccount": {
      "field": "Debit account",
      "label": "I will debit",
      "subtitle": "Select which account the funds will debit",
      "noOptions": "No debit accounts found for this entity",
      "placeholder": "Select a debit account"
    },
    "creditAccount": {
      "field": "Credit account",
      "label": "I will credit",
      "subtitle": "Select which account the funds will credit",
      "noOptions": "No credit accounts found for this entity",
      "placeholder": "Select a credit account"
    },
    "reference": {
      "label": "Reference",
      "placeholder": "Enter reference",
      "maxLengthMessage": "Field must be 100 characters or less",
      "specialCharactersReferenceMessage": "Please remove any special characters except /-?:().,'+"
    },
    "amount": {
      "label": "Amount",
      "placeholder": "Enter amount",
      "subtitle": "I will debit exactly. You can change fixed side by using dropdown"
    },
    "displayAccounts": "Displaying all accounts for {{entity}}.",
    "errors": {
      "insufficientFunds": "Insufficient balance in debit account to complete transfer",
      "minimumAmount": "The amount you have entered is below the minimum allowed amount"
    },
    "fixedSide": {
      "label": "Fixed side",
      "placeholder": "Select fixed side"
    }
  },
  "liveRate": "Live rate",
  "indicativeRate": "Indicative rate",
  "liveRateExpire": "The live rate will expire in",
  "amountsIndicativeCard": {
    "title": "Amounts indicative",
    "content": "The final send amounts may vary based on the exchange rate viewed and confirmed after submitting the balance transfer."
  },
  "bookFx": {
    "title": "Please note",
    "content": {
      "active": "By clicking ‘Book FX’ you will enter into a legal contract with Alpha to buy or sell the currencies you have selected.",
      "inactive": "Final send amounts may vary. Click ‘Request live rate’ to view the counter convention FX rate and book balance transfer."
    }
  },
  "insufficientFundsAlert": {
    "title": "Insufficient balance to complete transfer",
    "content": "Please top up account with sufficient funds and try again"
  },
  "liveRateAlert": "Unable to fetch live rate",
  "indicativeRateAlert": "Unable to fetch indicative rate",
  "minimumAmountAlert": {
    "title": "The amount you have entered is below the minimum allowed amount",
    "content": "You cannot send an amount lower than 1.00 {{currency}}"
  },
  "balanceTransfer": "Balance Transfer",
  "fixed": "Fixed",
  "successfulTransfer": {
    "title": "Balance transfer successfully submitted",
    "viewTransfer": "View transfer"
  },
  "approvedTransfer": {
    "title": "Balance transfer successfully approved"
  },
  "approvedAndSubmittedTransfer": {
    "title": "Balance transfer successfully submitted and approved"
  },
  "approvedAndReleasedTransfer": {
    "title": "Balance transfer successfully approved and released"
  },
  "released": "Balance transfer successfully released",
  "unsuccessfulTransfer": {
    "title": "Balance transfer could not be submitted",
    "body": "Please try again, and if the issue persists, contact Client Services"
  },
  "unsuccessfulApproval": {
    "title": "Balance transfer requires approval",
    "body": "Your Balance Transfer has been submitted successfully, but it requires manual approval to be sent."
  },
  "approval": {
    "error": {
      "title": "Balance transfer could not be approved"
    },
    "progress": "Approving Balance Transfer"
  },
  "release": {
    "progress": "Releasing Balance Transfer"
  },
  "exchangeRateConfirmed": {
    "title": "Exchange rate successfully confirmed",
    "body": "Your transfer is now complete."
  },
  "unsuccessfulRelease": {
    "title": "Balance transfer needs to be released",
    "body": "Your Balance Transfer has been submitted and approved successfully, but it still requires manual releasing.",
    "bodyApproval": "Your Balance Transfer has been approved successfully, but it still requires manual releasing."
  },
  "balanceTransferSuccessful": "Balance Transfer Successful",
  "balanceTransferCreatedAndApproved": "Balance Transfer created and approved",
  "quoteExpired": "Your quote has timed out. Please request a new live rate.",
  "requestingQuote": "Requesting live rate",
  "duplicateTradesAlert": "There was an error checking for duplicate trades",
  "bookingAlert": {
    "title": "There was an error with your booking",
    "body": "Please request a new live rate. If the issue persists, please contact Client Services."
  },
  "transferActionModal": {
    "reject": {
      "title": "Are you sure you want to reject this Balance Transfer?",
      "body": "This transfer will be rejected permanently. This action cannot be undone.",
      "success": "This transfer was successfully rejected.",
      "error": {
        "title": "Balance transfer could not be rejected"
      },
      "fxRateError": {
        "title": "Unable to Reject Balance Transfer",
        "body": "A live FX rate is currently active for this Balance Transfer. Please wait a moment for it to expire, then try again."
      },
      "confirm": "Yes, reject"
    },

    "delete": {
      "title": "Are you sure you want to delete this Balance Transfer?",
      "body": "This transfer will be deleted permanently. This action cannot be undone.",
      "success": "This transfer was successfully deleted.",
      "error": {
        "title": "Balance transfer could not be deleted"
      },
      "confirm": "Yes, delete"
    }
  }
}
